<template>
  <div class="container">
    <v-flex xs12 sm12 d-flex>
      <v-card v-if="$store.state.subProject">
        <v-toolbar
          color="light-green lighten-2"
          dark
          style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
          @click="forecastReadyDaily = !forecastReadyDaily"
        >
          <v-toolbar-title
            center
            style="color: white !important; text-align: center !important;"
            class="justify-center"
          >
            <h4 class="text-xs-center">
              <v-icon class="icon">mdi-bug</v-icon>PLAGAS Y ENFREMEDADES
            </h4>
          </v-toolbar-title>
        </v-toolbar>

        <div class="main">
          <v-layout row wrap>
            <v-flex md4 sm4 lg4>
              <h4 class="text-xs-left">Fecha: {{ date }}</h4>
            </v-flex>
            <v-flex md4 sm4 lg4>
              <v-select
                :items="agroUnits"
                name="name"
                item-text="name"
                label="Ubicación"
                @change="selectAgroUnit($event)"
              />
            </v-flex>
            <v-flex md4 sm4 lg4>
              <v-select
                v-if="tunnels"
                :items="tunnels"
                name="name"
                item-text="name"
                label="Túnel"
                @change="selectTunnels($event)"
              />
            </v-flex>
          </v-layout>
          <template v-if="todayReport">
            <br />
            <br />
            <h3 class="text-xs-center">
              REPORTE DE HOY ENVIADO!
              <br />
              <v-btn flat large block class="trash" @click="clickDelete(props)">
                ELIMINAR REPORTE<v-icon>mdi-delete</v-icon>
              </v-btn>
            </h3>
          </template>
          <br />
          <br />
          <div class="table" v-if="!todayReport">
            <v-data-table
              v-if="tunnel"
              :headers="headers"
              :items="$store.state.plaguesReports"
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template v-slot:items="props" class="old">
                <tr :class="props.item.new">
                  <td class="text-xs-center">{{ location }}</td>
                  <td class="text-xs-center">{{ week }}</td>
                  <td class="text-xs-center">{{ tunnel }}</td>
                  <td class="text-xs-center">{{ props.item.line }}</td>
                  <td class="text-xs-center">
                    <v-select
                      v-model="props.item.block"
                      :rules="[(v) => !!v || 'Selecciona un Bloque!']"
                      :items="block"
                      outline
                      small
                      class="select"
                      label="Bloque"
                    />
                  </td>
                  <td class="text-xs-center">
                    <v-select
                      v-model="props.item.plagueName"
                      :rules="[(v) => !!v || 'Selecciona una Plaga!']"
                      :items="plagas"
                      outline
                      small
                      class="select"
                      label="Plagas"
                    />
                  </td>
                  <td class="text-xs-center">
                    <v-select
                      v-model="props.item.plantLocation"
                      :rules="[(v) => !!v || 'Selecciona una Plaga!']"
                      :items="plantLocation"
                      outline
                      small
                      class="select"
                      label="Ubicación"
                    />
                  </td>
                  <td class="text-xs-center">
                    <v-select
                      v-model="props.item.stratus"
                      :rules="[(v) => !!v || 'Selecciona una Plaga!']"
                      :items="stratus"
                      outline
                      small
                      class="select"
                      label="Estrato"
                    />
                  </td>
                  <td class="text-xs-center quantity">
                    <v-text-field
                      v-model="props.item.individuals"
                      :rules="[(v) => !!v || 'Item is required']"
                      outline
                      class="text-xs-center"
                      type="number"
                      step="1"
                    />
                  </td>
                  <td class="text-xs-center">
                    <v-text-field
                      v-model="props.item.comment"
                      label="..."
                      outline
                    />
                  </td>
                  <td>
                    <v-btn color="blue" fab small dark @click="add(props)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </td>
                  <td class="delete" v-if="props.item.new">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn flat @click="remove(props)" v-on="on">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>ELIMINAR</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div v-if="!todayReport">
            <v-btn class="submit" color="green" right @click="submit()"
              >Finalizar</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  data() {
    return {
      date: null,
      headers: [
        {
          text: "Ubicación",
          align: "center",
          // sortable: true,
          value: "ubicacion",
        },
        { text: "Semana", value: "semana" },
        { text: "Túnel", value: "tunel" },
        { text: "Linea", value: "line" },
        { text: "Bloque", value: "bloque" },
        { text: "Hallazgo", value: "hallazgo" },
        { text: "Ubicación", value: "ubicacion" },
        { text: "Estrato", value: "estrato" },
        { text: "Cantidad", value: "intensidad" },
        { text: "Comentarios", value: "comentarios" },
        { text: "Mas", value: "mas" },
      ],
      // plagas: [
      //   "Trips",
      //   "Chinchi",
      //   "Mosca blanca",
      //   "Piojo harinoso",
      //   "Trips",
      //   "Soldado",
      //   "Drosophila",

      //   "Acaro Blanco",
      //   "Lepidopteros",
      //   "Coleopteros",
      //   "Chiche lygus",
      //   "Pulgon",
      //   "Araña roja",
      //   "Gallina ciega",

      //   "Roya",
      //   "Rhizoctonia",
      //   "Phytophthora",
      //   "Fusarium",
      //   "Botryosphaeria",
      //   "Botrytis",
      //   "Cenicilla",
      //   "Fumagina",

      //   "Californicus",
      //   "Chrysoperla",
      //   "Catarinita",
      //   "Persimilis",
      //   "Chinche Pirata",

      //   "Otro",
      //   "Ninguna",
      // ],
      plagas: [
        "Pulgon",
        "Mosca blanca",
        "Araña roja",
        "Trips",
        "Lepidopteros",
        "Mosca fruta",
        "Roya",
        "Botrytis",

        "Otro",
        "Ninguna",
      ],
      pagination: {
        rowsPerPage: 20,
      },
      agroUnits: null,
      agroUnitId: null,
      block: ["ADELANTE", "MEDIO", "ATRAS"],
      stratus: ["ALTO", "MEDIO", "BAJO"],
      plantLocation: [
        "APICE",
        "HOJA HAZ",
        "HOJA ENVEZ",
        "FLOR",
        "FRUTO",
        "CORONA",
        "SUSTRATO",
      ],
      location: null,
      tunnel: null,
      tunnels: null,
      week: null,
      items: [],
      todayReport: null,
      report: {
        name: null,
        week: null,
        createdDate: null,
        agroUnitId: null,
        tunelId: null,
        userId: null,
      },
    };
  },
  created: async function() {
    this.date = moment()
      .tz("America/Los_Angeles")
      .locale("es")
      .format("LL");

    this.getWeekNumber(new Date());
    this.plagueReports = this.$store.state.plaguesReports;

    let agroUnitId = this.$store.state.subProjectId;

    await this.$axios
      .get(`/api/parcelByAgroUnit/${agroUnitId}`)
      .then((data) => {
        this.agroUnits = data.data;
      });
  },
  methods: {
    selectAgroUnit: async function(event) {
      this.location = event;
      this.agroUnitId = this.agroUnits.find((x) => x.name === event).id;

      this.$axios
        .get(`/api/tunelByPacerlId/${this.agroUnitId}`)
        .then((data) => {
          console.log("TUNEL", data);
          this.tunnels = data.data;
        });
    },
    selectTunnels(event) {
      this.items = [];
      this.tunnel = null;
      this.tunnel = event;

      let tunelId = this.tunnels.find((x) => x.name === event).id;
      this.report.tunelId = this.tunelId;

      let activeTunnel = this.tunnels.find((x) => x.id === tunelId);
      console.log("id", tunelId);

      let payload = {
        tunelId: tunelId,
        agroUnitId: this.agroUnitId,
        date: new Date(),
        date2: new Date(),
      };

      this.$axios
        .get(
          `/api/PlaguesReports/${payload.agroUnitId}/${payload.tunelId}/${payload.date}/${payload.date2}`
        )
        .then((data) => {
          console.log("RES", data);
          if (data.data.length > 0) {
            this.todayReport = data.data;
          } else {
            this.todayReport = null;
          }
        });

      for (let index = 0; index < activeTunnel.lines; index++) {
        this.items.push({
          plagueReportId: null,
          line: index + 1,
          plants: "",
          range: 1,
          plagueName: null,
          individuals: 0,
          comment: "",
          location: this.location,
          stratus: "",
          plantLocation: "",
        });
      }
      this.report.week = this.week;
      this.report.createdDate = new Date();
      this.report.agroUnitId = this.agroUnitId;
      this.report.tunelId = tunelId;
      this.report.userId = this.$store.state.userId;

      this.$store.commit("plaguesReports", this.items);
    },

    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      // Return array of year and week number

      this.week = weekNo;
    },
    clickDelete() {
      // console.log(this.todayReport[0].id);
      let reportId = this.todayReport[0].id;
      let x = confirm("Estas seguro");
      if (x) {
        this.deleteReport(reportId);
      }
    },
    deleteReport(reportId) {
      let id = reportId;
      // alert(reportId);
      this.$axios.post(`/api/DeletePlaguesReports/`, { id }).then((data) => {
        // console.log(data);
        alert(data.data);
      });
    },
    add(event) {
      let chuy = event.item;

      let newReport = {
        block: chuy.block,
        line: chuy.line,
        plagueName: null,
        individuals: 0,
        new: "true",
        stratus: chuy.stratus,
        plantLocation: chuy.plantLocation,
      };

      this.items.insert = function(index, item) {
        this.splice(index, 0, item);
      };
      this.items.insert(event.item.line, newReport);
    },
    remove(event) {
      this.items.remove = function(index) {
        this.splice(index, 1);
      };
      this.items.remove(event.item.line);
    },
    submit: async function() {
      console.log(this.report);

      await this.$axios
        .post(`/api/PlaguesReports`, this.report)
        .then((data) => {
          let PlagueReportId = data.data.id;
          this.items.forEach((item) => {
            item.plagueReportId = PlagueReportId;
          });
          this.$axios.post(`/api/Findings`, this.items).then((data) => {
            console.log("response", data);
          });
          // console.log("items", this.items);
        });

      this.items = [];
      this.tunnel = null;
      this.$store.commit("plaguesReports", this.items);
    },
  },
};
</script>

<style scoped>
.main {
  padding: 30px !important;
}

.trash {
  background-color: red;
}

.icon {
  margin-right: 10px;
}

.table {
  border-radius: 3px;
}

tr {
  height: 20px !important;
}

.old:hover {
  border: 1px solid blue !important;
}

.true {
  background-color: lightblue !important;
}

.quantity {
  width: 5%;
}

.delete {
  width: 1%;
  padding: 0px !important;
}

.v-input {
  top: 15px !important;
}

input {
  font-size: 20px !important;
  height: 30px !important;
}

.submit {
  float: right;
}
</style>
